export const isBlocklisted = (mdn: string, blocklistedNumbers?: string[], blocklistedPrefixes?: string[]) => {
    if (!blocklistedNumbers && !blocklistedPrefixes) return false;

    if (blocklistedNumbers?.includes(mdn)) return true;
    if (blocklistedPrefixes?.some((prefix) => mdn.startsWith(prefix))) return true;
};
